import * as actionType from "./actionTypes";
import { postRequest, getRequest, processError } from "../../utils/apiHandlers";
import { customerRequest } from "../../utils/customerApi";
import { LOADING_STATE, LS_ITEM, NOTIF_TYPE } from "../../utils/stateTypes";
import _notif from "../notification";
import { saveCheckoutDetails } from "../localStorage";
import _cart from "../cart";

/* =========================== PRODUCTS =========================== */

// The whole catalogue is loaded when the site opens (managed in the admin), and again when the customer logs in or out:
// the Derma 2.0® products are only included for a logged in customer
export const loadProducts = () => (
  async (dispatch) => {
    const lsItem = LS_ITEM.PRODUCTS;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    try {
      const products = await customerRequest("/Products");
      dispatch({ type: actionType.SET_PRODUCTS, products });
      //Drop anything in a saved cart that is no longer for sale (or no longer available to this visitor)
      dispatch(_cart.actions.removeUnavailable(products.map((x) => x.sku)));
      dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
    }
    catch (error) {
      processError(dispatch, _notif, lsItem)(error);
    }
  }
);

// The Derma 2.0® cards on /products-derma for visitors who haven't logged in (no prices)
export const loadDermaPreview = () => (
  (dispatch) => {
    getRequest("/Products/DermaPreview",
      (dermaPreview) => dispatch({ type: actionType.SET_DERMA_PREVIEW, dermaPreview }),
      () => dispatch({ type: actionType.SET_DERMA_PREVIEW, dermaPreview: [] }),
    );
  }
);

// The delivery fee rules (set on the server), so the cart shows what the checkout will charge
export const loadDeliveryOptions = () => (
  (dispatch) => {
    getRequest("/Shop/DeliveryOptions",
      (delivery) => dispatch({ type: actionType.SET_DELIVERY, delivery }),
      () => { /* The checkout still adds the right fee - the cart just can't show it */ },
    );
  }
);

/* =========================== CHECKOUT =========================== */

// Creates the order on the server and sends the customer to Yoco's secure payment page
export const checkout = (items, details) => (
  (dispatch) => {
    const lsItem = LS_ITEM.CHECKOUT;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    //Remember the details in case they come back from Yoco without paying
    saveCheckoutDetails({ ...details, acceptedTerms: false });

    //As the logged in customer, if any - Derma 2.0® products can only be bought by a customer
    customerRequest("/Shop/CreateCheckout", "POST", {
      ...details,
      items: items.map((x) => ({ sku: x.sku, quantity: x.quantity })),
    })
      .then((result) => {
        //Leave the loading state on - the page is navigating away
        window.location.href = result.redirectUrl;
      })
      .catch(processError(dispatch, _notif, lsItem));
  }
);

/* =========================== ORDER STATUS =========================== */

const setOrderStatus = (order) => (
  {
    type: actionType.SET_ORDER_STATUS,
    order,
  }
);

export const loadOrderStatus = (reference, silent=false) => (
  (dispatch) => {
    const lsItem = LS_ITEM.ORDER_STATUS;
    if (!silent) {
      dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    }

    getRequest(`/Shop/OrderStatus?reference=${encodeURIComponent(reference)}`,
      (order) => {
        dispatch(setOrderStatus(order));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      () => dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.ERROR)),
    );
  }
);

/* =========================== CONTACT =========================== */

export const sendContactMessage = (message, successCB) => (
  (dispatch) => {
    const lsItem = LS_ITEM.CONTACT_SEND;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    postRequest("/Contact/SendContactMessage",
      message,
      () => {
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        dispatch(_notif.actions.queueNotification("Thanks for submitting!", NOTIF_TYPE.SUCCESS));
        successCB();
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);
